// =========================================================
// * Vuetify Material Dashboard PRO - v2.0.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vuetify-material-dashboard-pro
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
import Vue from 'vue'

import App from './App.vue'
import router from './router/index'
import store from './store'
import './plugins/base'
import './plugins/customer-components'
import './plugins/filter'
import './plugins/price-elements'
import './plugins/vee-validate'
import './plugins/v-clipboard'
import './plugins/datetime'
import './plugins/vue-world-map'
import './plugins/vue-google-maps'
import './plugins/draggable'
import echo_instance from './plugins/laravel-echo'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import _ from 'lodash'
import moment from 'moment'
import data from './plugins/data'
import localStorage from './plugins/localstorage'
import GmapCluster from 'vue2-google-maps/dist/components/cluster'
import msal from 'vue-msal'
import Chartist from 'vue-chartist'
Vue.use(Chartist)

Vue.use(msal, {
    auth: {
      authority: 'https://login.microsoftonline.com/c0e83cf6-d183-443f-89da-65db03b618ed',
      clientId: '2bc60c91-85ef-41bf-ba6a-203bbb072c0e',
      redirectUri: () => `${window.location.origin}/pages/login`,
    },
})

Vue.component('GmapCluster', GmapCluster)

Vue.config.productionTip = false

new Vue({
  i18n,
  store,
  vuetify,
  router,
  beforeCreate: function () {
    Vue.prototype.$get = data.fetch
    Vue.prototype.$post = data.post
    Vue.prototype.$put = data.put
    Vue.prototype.$del = data.del
    Vue.prototype.$patch = data.patch
    Vue.prototype.$echo = echo_instance
    Vue.prototype.$_ = _
    Vue.prototype.$moment = moment
    Vue.prototype.$axios = data.http
    Vue.prototype.$axios_dev = data.http_dev
    Vue.prototype.$getUser = () => JSON.parse(localStorage.get('user') || '{}') || {}
    Vue.prototype.$playSound = (path, volume = 1) => {
      var audio = new Audio(path)
      audio.volume = volume
      audio.play()
}
  },
  render: h => h(App),
})
.$mount('#app')
